import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Issue #85: 全画面のタブタイトルが public/index.html の "Dashboard App" 固定で、
// 複数タブを開くとどれがどの画面か区別できなかった。ルートごとに document.title を
// 差し替える。
export const APP_NAME = "NOCE Timesheet System";

// キーは末尾スラッシュを除いた正規形。App.js のルート定義（"/", "/dashboard",
// "/profile", "/login/"）と対応する。
export const PAGE_TITLES = {
	"/": "Home",
	"/dashboard": "Dashboard",
	"/profile": "My Profile",
	"/login": "Login",
};

/**
 * 末尾スラッシュを除いた比較用のパスを返す。
 *
 * App.js のルート定義は "/login/" と末尾スラッシュ付きだが Header のリンクは
 * "/login" で、react-router はどちらでも同じ画面へ解決する。タイトル側だけが
 * 表記の違いで引けなくなることを防ぐため、比較前に正規化する。
 * ルート "/" だけは空文字にならないようそのまま返す。
 */
export const normalizePathname = (pathname) => {
	if (!pathname) {
		return "/";
	}
	if (pathname === "/") {
		return "/";
	}
	return pathname.replace(/\/+$/, "");
};

/**
 * 指定パスに対応するタブタイトルを組み立てる。
 *
 * 未知のパス（ルート定義の無い URL を直接開いた場合など）はアプリ名だけを返し、
 * "undefined | ..." のような表示にならないようにする。
 */
export const buildPageTitle = (pathname) => {
	const label = PAGE_TITLES[normalizePathname(pathname)];
	return label ? `${label} | ${APP_NAME}` : APP_NAME;
};

/** 現在のルートに応じて document.title を更新する。 */
export const usePageTitle = () => {
	const { pathname } = useLocation();

	useEffect(() => {
		document.title = buildPageTitle(pathname);
	}, [pathname]);
};
